import {
  CreateDocumentsTemplateDocument,
  CreateDocumentsTemplateMutation,
  CreateDocumentsTemplateMutationVariables,
  GetDocumentTemplatesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateDocumentTemplate = () => {
  const [mutate, { loading }] = useMutation(CreateDocumentsTemplateDocument, {
    extractorFn: (data: CreateDocumentsTemplateMutation) =>
      data.documentsMutations.createDocumentsTemplate,
  })

  const createDocumentTemplate = (variables: CreateDocumentsTemplateMutationVariables) => {
    return mutate({
      variables,
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GetDocumentTemplatesDocument,
        },
      ],
    })
  }

  return { createDocumentTemplate, loading }
}
